export default __webpack_public_path__ + "static/media/Mandarin_Costa_Navarino_Logo.ff080d5d.jpg";